import { faPlus, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClickAwayListener, Fab, TextField } from '@mui/material';
import SubsystemSegment from 'components/AgentTemplateEditView/EditBoards/GenericComponentsEditBoard/SubsystemWizard/SubsystemSegment';
import { IErrorResponse } from 'components/general/types';
import { ISubsystem } from 'components/general/types/power';
import Wizard from 'components/general/wizards/Wizard';
import { useActiveEntities, useSnackbar } from 'hooks';
import { SatelliteApi } from 'middleware/SatelliteApi/api';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { animated, useSpring } from 'react-spring';
import theme from 'theme';
import useStyles from './styles';

const AddSubsystemInlay = () => {
  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState('');
  const { classes } = useStyles();
  const [inputProps, inputApi] = useSpring(() => ({ width: 75 }));
  const [fabProps, fabApi] = useSpring(() => ({ borderRadius: 50 }));
  const [iconProps, iconApi] = useSpring(() => ({
    borderColor: theme.palette.primary.light + '00',
  }));
  const dispatch = useDispatch();
  const { Subsystem } = SatelliteApi;
  const { branch } = useActiveEntities();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const handleSubmit = () => {
    if (!name) return;
    setEditMode(false);
    setLoading(true);
    dispatch(
      Subsystem.actions.createSubsystem({
        branchId: branch.id,
        name,
        type: 'Subsystem',
        successCallback: () => {
          setLoading(false);
          enqueueSnackbar('Subsystem created successfully', {
            variant: 'success',
          });
        },
        failureCallback: (response: IErrorResponse) => {
          setLoading(false);
          enqueueSnackbar(response.error.message);
        },
      })
    );
  };

  useEffect(() => {
    setName('');
    inputApi.start({ width: editMode ? 150 : 75 });
    fabApi.start({ borderRadius: editMode ? 4 : 50 });
    iconApi.start({
      borderColor: theme.palette.primary.light + (editMode ? 'FF' : '00'),
    });
  }, [editMode, inputApi, fabApi, iconApi]);

  const AnimatedFab = animated(Fab);

  return (
    <div className={classes.addSubsystemInlay}>
      <ClickAwayListener onClickAway={() => setEditMode(false)}>
        <AnimatedFab
          variant="extended"
          size="medium"
          color="primary"
          sx={{ backgroundColor: theme.palette.primary.dark }}
          onClick={() => (editMode ? handleSubmit() : setEditMode(true))}
          disableFocusRipple
          style={fabProps}
          disabled={loading}
        >
          <animated.div className={classes.plusIcon} style={iconProps}>
            <FontAwesomeIcon icon={loading ? faSpinner : faPlus} spin={loading} />
          </animated.div>
          <animated.div
            style={inputProps}
            // Prevent input from triggering Fab submit
            onClick={(e) => editMode && e.stopPropagation()}
            onKeyUp={(e) => editMode && e.preventDefault()}
          >
            {editMode ? (
              <form onSubmit={handleSubmit}>
                <TextField
                  placeholder="Subsystem"
                  autoFocus
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </form>
            ) : (
              'Subsystem'
            )}
          </animated.div>
        </AnimatedFab>
      </ClickAwayListener>
    </div>
  );
};

const SubsystemWizard = () => {
  const { subsystems } = useActiveEntities();

  return (
    <div>
      <AddSubsystemInlay />
      <Wizard>
        {subsystems.map((subsystem: ISubsystem) => {
          return <SubsystemSegment subsystem={subsystem} key={subsystem.id} />;
        })}
      </Wizard>
    </div>
  );
};
export default SubsystemWizard;
